<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$mq | mq({
      mobile: false,
      tablet: false,
      desktop: false,
    })"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="control"
        small
        fab
        v-on="on"
        @click="emit('info')"
      >
        <v-icon>mdi-information-outline mdi-24px</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-icon>mdi-information-outline mdi-24px</v-icon>
        <span
          class="headline"
          style="margin-left: 1em;"
        >
          {{ $t('attributions.heading') }}
        </span>
      </v-card-title>
      <v-card-text>
        <!--------------------------------------------------------->
        <div
          class="ma-4"
        >
          <div class="list-item-group">
            <div class="list-item">
              <div class="list-item-content">
                <span class="bold-text text-wrap">
                  {{ $t('attributions.mapContent') }}:<br>
                </span>
                <span
                  v-for="(entry, i) in $store.getters.htmlAttributions"
                  :key="i+100"
                  class="light-text text-wrap"
                >
                  <!--eslint-disable-next-line vue/no-v-html-->
                  <span v-html="entry" /><br>
                </span>
                <span
                  v-for="(entry, i) in information.mapData"
                  :key="i"
                  class="light-text text-wrap"
                >
                  {{ entry }}<br>
                </span>
              </div>
            </div>
            <div class="list-item">
              <div class="list-item-content">
                <span class="bold-text text-wrap">
                  {{ $t('settingsView.technicallyOperatedBy') }}:<br>
                </span>
                <v-img
                  src="mapedit-portal.png"
                  contain
                  width="128px"
                  style="margin: 8px"
                />
                <span class="light-text text-wrap">
                  Mensch und Maschine Infrastruktur GmbH<br>
                </span>
                <span class="light-text text-wrap">
                  MapEdit Portal Version {{ $mapeditPortalVersion }}<br>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--------------------------------------------------------->
      </v-card-text>
      <v-card-actions
        v-if="hideImprint != true"
      >
        <v-btn
          color="black"
          outlined
          text
          block
          @click="openImprint()"
        >
          {{ $t('settingsView.imprint') }}
        </v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-btn
          color="success"
          outlined
          text
          block
          @click="dialog = false"
        >
          {{ $t('various.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  EventBus,
} from '../../event-bus';

export default {
  name: 'Attributions',
  data() {
    return {
      dialog: false,
      information: this.$appConfig.information,
      responsibility: this.$appConfig.responsibility,
      hideImprint: this.$appConfig.hideImprint,
    };
  },
  methods: {
    emit(string) {
      EventBus.$emit(string);
    },
    openImprint() {
      this.dialog = false;
      this.$store.commit('closeAllMenus');
      this.$store.commit('showSettingsMenu');
      this.emit('openImprint');
    },
  },
};
</script>

<style scoped>
.control {
  border-radius:10px;
  margin: 0.25em;
}

.v-btn {
  width: 3em;
}
.list-item {
  margin-bottom: 16px;
}
.bold-text {
  font-weight: normal;
  font-size: larger;
  color: #222222;
}

.light-text {
  font-weight: normal;
  color: #777777
}
</style>
